export default {
  delete: ({ DELETE }, idConfiguration) =>
    new Promise((resolve, reject) => {
      if (!idConfiguration) {
        reject(new Error(
          `Erreur paramètre : idConfiguration non valide "${idConfiguration}"`
        ))
      }
      return DELETE(`production/configurations/${idConfiguration}`)
        .then(reponse => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
